/* HK social modules — reel-rail auto-drift, ported verbatim from the prototype's
   assets/js/main.js ([data-reel-rail] block). Gentle auto-scroll over a native
   scroll container so the reel cards stay clickable (a transform marquee cancels
   clicks on a moving target). Driven by a timer + elapsed-time delta (NOT
   requestAnimationFrame, which the browser pauses whenever the tab/preview isn't
   the visible foreground), so it keeps moving at a constant speed everywhere.
   Content is duplicated 2x, so wrapping at half the scroll width is seamless.
   Pauses on hover, focus, touch and wheel; re-syncs to the real scroll position
   when the user lets go. Double-init guarded for Shopify section re-renders. */
(function () {
  'use strict';

  function initReelRails() {
    var reelRails = document.querySelectorAll('[data-reel-rail]');
    var reelReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var nowMs = function () { return (window.performance && performance.now) ? performance.now() : (+new Date()); };
    Array.prototype.forEach.call(reelRails, function (rail) {
      if (rail.dataset.hkReelInit === '1') return; /* guard double-init */
      rail.dataset.hkReelInit = '1';
      if (reelReduce) return; /* reduced-motion: leave it as a static, swipeable rail */
      var SPEED = 45;         /* px per second — gentle, matches the old marquee feel */
      var paused = false, idleTimer, last = null, pos = rail.scrollLeft;
      var pause = function () { paused = true; };
      var resume = function () { pos = rail.scrollLeft; last = null; paused = false; };
      var nudge = function () { pause(); clearTimeout(idleTimer); idleTimer = setTimeout(resume, 1500); };
      rail.addEventListener('mouseenter', pause);
      rail.addEventListener('mouseleave', resume);
      rail.addEventListener('focusin', pause);
      rail.addEventListener('focusout', resume);
      rail.addEventListener('touchstart', nudge, { passive: true });
      rail.addEventListener('wheel', nudge, { passive: true });
      setInterval(function () {
        if (paused || rail.scrollWidth <= rail.clientWidth) { last = null; return; }
        var t = nowMs();
        if (last === null) { last = t; pos = rail.scrollLeft; return; }
        pos += SPEED * (t - last) / 1000; last = t;
        var half = rail.scrollWidth / 2;
        if (pos >= half) pos -= half;
        rail.scrollLeft = pos;
      }, 20);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReelRails);
  } else {
    initReelRails();
  }
  /* Shopify theme editor re-renders sections without a page load */
  document.addEventListener('shopify:section:load', initReelRails);
})();
